module.exports = __webpack_public_path__ + "assets/example.d26d02f7.svg";